import get from 'lodash.get';
import md5 from 'md5';
import { getCurrentSoftwareNumber } from '../store/software-number';
import { getUserId } from '../store/selectors';
import getStore from '../store';

const RETRY_ATTEMPTS = 5;

function safeGet(key) {
  try {
    return JSON.parse(localStorage[key]);
    // eslint-disable-next-line no-empty
  } catch (e) {}
}

export function toLsKey(key) {
  const userId = getUserId(getStore().getState());
  return md5([key, getCurrentSoftwareNumber(), userId || 'all'].join('-'));
}

export function setItem(key, value, retryCount = 0) {
  const item = {
    key,
    value,
    _u: Date.now(),
  };
  try {
    localStorage.setItem(toLsKey(key), JSON.stringify(item));
  } catch (error) {
    handleSetError(error, key, value, retryCount);
  }
}

function handleSetError(error, key, value, retryCount) {
  // eslint-disable-next-line no-console
  console.error(error);
  const shouldTryAgain = retryCount < RETRY_ATTEMPTS;
  if (shouldTryAgain && removeOldestKey()) {
    setItem(key, value, retryCount + 1); // retry
  }
}

export function getSortedKeys() {
  return Object.keys(localStorage)
    .map(lsKey => ({
      lsKey,
      parsed: safeGet(lsKey),
    }))
    .filter(ls => ls.parsed && ls.parsed._u)
    .sort((a, b) => a.parsed._u - b.parsed._u)
    .map(ls => ls.lsKey);
}

function removeOldestKey() {
  const oldestKey = getSortedKeys().shift();
  if (!oldestKey) {
    return false;
  }
  localStorage.removeItem(oldestKey);
  return true;
}

export function getItem(key) {
  const lsKey = toLsKey(key);
  const parsed = safeGet(lsKey);
  return get(parsed, 'value');
}

export function removeKeyByValue(key) {
  const allKeys = getSortedKeys();
  if (allKeys.length > 0) {
    let values;
    for (let value of allKeys) {
      values = JSON.parse(localStorage.getItem(value));
      if (values?.key && values.key === key) {
        localStorage.removeItem(value);
      }
    }
  }
}
